export default __webpack_public_path__ + "static/media/P10010.468553ec.png";